(function ($) {
  $(function () {
    $('.js-operation-year-select').SumoSelect();
  });
})(jQuery);
